import React from "react";
import { Button, Popconfirm, Tag } from "antd";
import {
  DownloadOutlined,
  EyeOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

const FirmDocumentColumns = (deleteFile, handlePreview) => [
  {
    title: "Dosya Başlığı",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Açıklama",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Eklenme Tarihi",
    dataIndex: "addedDate",
    key: "addedDate",
    render: (date) => new Date(date).toLocaleDateString("tr-TR"),
  },
  {
    title: "Ekleyen Kullanıcı",
    dataIndex: "addedUser",
    key: "addedUser",
    render: (addedUser, record) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span>{`${addedUser.name} ${addedUser.surname}`}</span>
        <Tag color={record.isAddedByPersonnel ? "blue" : "green"}>
          {record.isAddedByPersonnel ? "Personel" : "Firma"}
        </Tag>
      </div>
    ),
  },
  {
    title: "İşlemler",
    key: "actions",
    render: (_, record) => (
      <div style={{ display: "flex", gap: "8px" }}>
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => handlePreview(record.fileUrl)}>
          Önizle
        </Button>
        <Button
          type="link"
          icon={<DownloadOutlined />}
          onClick={() => window.open(record.fileUrl, "_blank")}>
          İndir
        </Button>
        <Popconfirm
          title="Dosyayı Sil"
          description="Bu dosyayı silmek istediğinize emin misiniz?"
          onConfirm={() => deleteFile(record.id)}
          okText="Evet"
          cancelText="Hayır">
          <Button type="link" danger icon={<DeleteOutlined />}>
            Sil
          </Button>
        </Popconfirm>
      </div>
    ),
  },
];

export default FirmDocumentColumns;
